/**
 * @param {Object<string,*>} obj
 */
export const toArray = (obj) => Object.keys(obj).map((key) => ({ key, value: obj[key] }));

// const toObj = (arr) => {
//   const result = {};
//   arr.forEach(({ key, value }) => {
//     result[key] = value;
//   });
//   return result;
// };

// const filterObj = (obj, fn) => toObj(toArray(obj).filter(({ key, value }) => fn(key, value)));

/**
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export const isNullable = (value) => value === null || value === undefined;

/**
 *
 * @param {Object | null | undefined} obj
 * @returns {boolean} true if object is empty
 */
export const isEmpty = (obj) => {
  if (isNullable(obj)) {
    return true;
  }
  return Object.keys(obj || {}).length === 0;
};

/**
 *
 * @param {number | string} price
 * @returns {string}
 */
export const formatPrice = (price) => `$${Number(price).toFixed(2)}`;

/**
 *
 * @param {number | string} points
 * @returns {string}
 */
export const formatPoints = (points) => Number(points).toLocaleString('en-US');

/**
 * @param {string} string
 * @returns {string} string with first letter capitalized
 * */
export const upperCaseFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

/**
 * @param {string} string
 * @returns {string} Capitalized string
 * */
export function toCapitalizedCase(string) {
  return string
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 *
 * @param {string} url
 * @return {Record<string,unknown>}
 */
export function getUrlVars(url) {
  /** @constant
  *@type {Record<string,unknown>}`
  *@default
  */
  const vars = {};
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (_, key, value) => {
    vars[key] = decodeURIComponent(value);
  });
  return vars;
}

/**
 *
 * @param {number} number of product attributes
 * @returns {string} word representation of number of product attributes
 */
export function attributeNumToString(number) {
  return {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
  }[number] || 'zero';
}

/**
 *
 * @param {Product} product
 * @param {Boolean} hasColorSwatchesFlag
 * @param {Boolean} hasSizesFlag
 * @param {Boolean} hasTypesFlag
 * @returns {string} attributeNumToString
 */

export function numOfAttributes(product, hasColorSwatchesFlag, hasSizesFlag, hasTypesFlag) {
  let attributeCount = 0;

  if (hasColorSwatchesFlag) {
    attributeCount += 1;
  }
  if (hasSizesFlag) {
    attributeCount += 1;
    if (product.traits?.sizes?.hasWidth || product.traits?.sizes?.hasDressSplit) {
      attributeCount += 1;
    }
  }
  if (hasTypesFlag) {
    attributeCount += 1;
  }
  return attributeNumToString(attributeCount);
}

/**
 * generates random id like rdm-key-41-171353965872
 * @returns {string}
 */

export const randomGenerator = () => `rdm-key-${Math.floor(Math.random() * 1000)}-${Date.now()}`;

/**
 * returns percentage number based on valueRange of 1-3(bcom) or 1-7(mcom)
 * @param {number} value
 * @param {number} valueRange
 * @returns {number}
 */
export const reviewsPercentage = (value, valueRange) => {
  const midpoint = Math.ceil(valueRange / 2);
  return value <= midpoint
    ? ((value - 1) / (midpoint - 1)) * 50
    : 50 + ((value - midpoint) / (valueRange - midpoint)) * 50;
};

/**
 * @param {Record<string, any>} params
 * @returns {string}
 */

function buildQueryParamStringFromObject(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value != null && !(typeof value === 'string' && value.trim() === '')) {
      acc.append(key, value);
    }
    return acc;
  }, searchParams);
  return searchParams.toString();
}

/**
 * @param {Record<string, any>} context
 * @returns {Record<string, any>} - Returns param object for the given context
 */

/** @type {Record<string, string>} */
const paramMap = {
  pdpServer: 'pdpserver',
  shoppingMode: '_shoppingMode',
  regionCode: '_regionCode',
  currencyCode: 'currencyCode',
  customerState: '_customerState',
  deviceType: '_deviceType',
};
/**
 * @param {Record<string, any>} context
 * @returns {Record<string, any>}
 */
export const getContextParams = (context = {}) => {
  /** @type {Record<string, any>} */
  if (!context) return {};

  return Object.fromEntries(
    Object.entries(paramMap)
      .filter(([key]) => context[key])
      .map(([key, value]) => [value, context[key]]),
  );
};
/**
 *
 * @param {string} baseUrl
 * @param {Record<string, any>} params
 * @returns {string}
 */
export function buildUrl(baseUrl = '', params = {}) {
  if (!(typeof baseUrl === 'string') || Object.prototype.toString.call(params) !== '[object Object]') {
    return '';
  }

  const queryParams = buildQueryParamStringFromObject(params);
  let joinSymbol = '';
  if (queryParams.length) {
    joinSymbol = baseUrl.indexOf('?') !== -1 ? '&' : '?';
  }

  return `${baseUrl}${joinSymbol}${queryParams}`;
}

export default {};
